import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MissingTranslation implements MissingTranslationHandler {
    public handle(params: MissingTranslationHandlerParams) {
        console.error('missing translation for ', params.key);
        return params.key;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/missingTranslationHandler.ts